/* tslint:disable */
/* eslint-disable */
export enum LayoutKind {
  Sequential = 'Sequential',
  Explicit = 'Explicit',
  Auto = 'Auto'
}
